import React, { memo, useState, useEffect } from "react";
import { Button } from "@mui/material";
import {
  DrawerMain,
  HeaderSec,
  ContactMain,
  ContactWrap,
  UserAvatar,
  ViewJobs,
  ActionButton,
} from "./styles/NotificationsSlideStyle";
import orderimg from "../../../assets/images/orderimg.png";
import { NOTIFICATIONS } from "../../../constants/apiEndPoints";
import httpRequest from "../../../axios/index";
import { toast } from "react-hot-toast";
import { ReadAllNotifications } from "../../../services/notifications";
import CustomScrollbar from "../../shared/CustomScrollbar";
import MainButton from "../../shared/Button";
import SmallLoader from "../../shared/loader/SmallLoader";
import NotFoundIcon from "../../shared/NotFoundIcon";

const NotificationsSlide = ({ showDrawer, setshowDrawer }) => {
  const [AllNotifications, SetAllNotifications] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [Page, setPage] = useState(1);
  const [IsLastPage, setIsLastPage] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);

  const onCloseNotification = () => {
    setshowDrawer(false);
    setPage(1);
  };
  useEffect(() => {
    if (showDrawer) {
      GetAllNotifications();
    }
  }, [showDrawer, Page]);
  const GetAllNotifications = async () => {
    try {
      if (Page === 1) {
        setLoading(true);
      } else {
        setLoadingMore(true);
      }
      const resp = await httpRequest.get(`${NOTIFICATIONS}?page=${Page}`);

      if (resp?.status === 200 && resp?.data?.message === "Success") {
        setIsLastPage(resp?.data?.last_page);
        if (resp?.data?.data) {
          if (Page === 1) {
            SetAllNotifications(resp?.data?.data);
          } else {
            SetAllNotifications((pre) => [...pre, ...resp?.data?.data]);
          }
          await ReadAllNotifications();
        }
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Something went wrong";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const DeleteAllNotifications = async () => {
    try {
      setLoading(true);
      const resp = await httpRequest.delete(`${NOTIFICATIONS}/all`);
      if (resp?.status === 200) {
        toast.success(resp?.data?.message);
        SetAllNotifications([]);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Something went wrong";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handlePagination = () => {
    setPage((prevPage) => prevPage + 1);
  };

  return (
    <>
      <DrawerMain
        anchor="right"
        open={showDrawer}
        onClose={onCloseNotification}
      >
        <HeaderSec>
          <h6>Notifications</h6>
          <Button
            disabled={AllNotifications?.length === 0 || Loading}
            onClick={DeleteAllNotifications}
          >
            Delete All
          </Button>
        </HeaderSec>
        <CustomScrollbar>
          <ContactMain>
            {Loading && <SmallLoader center={true} />}
            {!Loading && (
              <>
                {AllNotifications && AllNotifications?.length === 0 && (
                  <NotFoundIcon MT="20" IconWidth="20" />
                )}
              </>
            )}

            {!Loading && AllNotifications && (
              <>
                {AllNotifications?.map((notification) => (
                  <ContactWrap key={notification.id} className="contactWrap">
                    <div className="ContactImg">
                      <UserAvatar alt={orderimg} src={orderimg} />
                    </div>
                    <div className="contactText">
                      <p>{notification.message}</p>
                      {/* <div className="contactAction">
            <ViewJobs>View Job</ViewJobs>
          </div> */}
                    </div>
                  </ContactWrap>
                ))}
              </>
            )}

            {/* 
          <ContactWrap className="contactWrap">
            <div className="ContactImg">
              <UserAvatar alt={orderimg} src={orderimg} />
            </div>
            <div className="contactText">
              <p>
                <span>John Allen</span> has accepted the Quote of $50 against
                this job.
              </p>
              <div className="contactAction contactBtn">
                <ActionButton className="accept">Accept</ActionButton>
                <ActionButton className="reject">Reject</ActionButton>
                <ActionButton className="profile">View Profile</ActionButton>
              </div>
            </div>
          </ContactWrap>
          <ContactWrap className="contactWrap">
            <div className="ContactImg">
              <UserAvatar alt={orderimg} src={orderimg} />
            </div>
            <div className="contactText">
              <p>
                <span>John Allen</span> has accepted the Quote of $50 against
                this job.
              </p>
              <div className="contactAction contactBtn">
                <ActionButton className="accept">Accept</ActionButton>
                <ActionButton className="reject">Reject</ActionButton>
                <ActionButton className="profile">View Profile</ActionButton>
              </div>
            </div>
          </ContactWrap> */}
          </ContactMain>
          {!Loading && !IsLastPage && AllNotifications.length > 0 && (
            <MainButton
              type="button"
              label="Load More"
              isLoading={loadingMore}
              onClick={handlePagination}
              MT="10"
            />
          )}
        </CustomScrollbar>
      </DrawerMain>
    </>
  );
};

export default memo(NotificationsSlide);
